import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyDhesVVl7M49nG_s_CUW5q-4Tmt203RkKY",
  authDomain: "u-go-taxi-service.firebaseapp.com",
  databaseURL: "https://u-go-taxi-service-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "u-go-taxi-service",
  storageBucket: "u-go-taxi-service.firebasestorage.app",
  messagingSenderId: "236028546144",
  appId: "1:236028546144:web:c9a3f4b243e9aebd328705",
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);

export { app, auth, db };